<template lang="pug">
  .card-box
    slot
</template>

<script>
  import Vue from 'vue'
  import { Component } from 'vue-property-decorator'

  @Component
  export default class Box extends Vue {
  }
</script>

<style scoped lang="scss">
  @import "../assets/stylesheets/variables";
  .card-box {
    border-radius: 4px;
    border: 1px solid $gray-1;

    > div {
      padding: 15px;
      border-bottom: 1px solid $gray-1;

      &:first-of-type {
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
      }

      &:last-of-type {
        border-bottom: 0;
        border-bottom-left-radius: 4px;
        border-bottom-right-radius: 4px;
      }
    }

    .box-head-title {
      font-size: 16px;
      color: $navy;
      font-weight: 600;

      .legend {
        font-size: 10px;
        color: $navy-light;
      }
    }
  }
</style>
